import { useEffect } from "react";
export const useKeyboardNavigationDetector = () => {
    useEffect(() => {
        let keyboardNavigation = false;
        const handleKeyDown = (e) => {
            if (!keyboardNavigation) {
                if (e.key === "Tab" || e.key.includes("Arrow")) {
                    keyboardNavigation = true;
                    document.body.setAttribute("data-keyboard-nav", "true");
                }
            }
        };
        const handleMouseMove = () => {
            if (keyboardNavigation) {
                keyboardNavigation = false;
                document.body.removeAttribute("data-keyboard-nav");
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("mousedown", handleMouseMove);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mousedown", handleMouseMove);
        };
    }, []);
};
